module.exports = __webpack_public_path__ + "static/filmdrop-processing-pipeline-de0cc8054771f6c4b0bd92f533f2ed80.svg";